<template>
  <div class="">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <a-input
          v-model:value="requestPayload.search"
          placeholder="请输入编码/名称/规格/型号"
          style="width: 260px"
          allowClear
          @change="handleSearch"
        ></a-input>

        <a-select
          :options="semiFinishedProductOptions"
          v-model:value="requestPayload.type"
          v-if="activeKey === null"
          @change="handleSearch"
          placeholder="请选择类型"
          style="width: 120px"
          allowClear
        >
        </a-select>
      </a-space>

      <a-space>
        <a-tooltip placement="top" v-if="materialTypeOptins.find((r) => r.value == activeKey)">
          <template #title>
            <span>
              {{ materialTypeOptins.find((r) => r.value == activeKey).example }}
            </span>
          </template>
          <QuestionCircleOutlined style="color: #fa8c16" />
        </a-tooltip>
        <a-button @click="handleUpdateMaterial('insert', null)" size="small" type="primary"
          >新增</a-button
        >

        <a-button
          @click="handleExportMaterial"
          size="small"
          :disabled="selectedRowKeys.length === 0 || exportButtonDisabled"
          >导出</a-button
        >
        <!-- <a-button @click="handleUpdateMaterial('versionUp', null)" size="small">
          物料版本更新
        </a-button> -->
      </a-space>
    </div>

    <div style="height: calc(100vh - 280px)" v-if="!loading">
      <a-table
        :data-source="table.data"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        bordered
        :pagination="false"
        :columns="columns"
        rowKey="id"
        :scroll="{ y: 'calc(100vh - 360px)', x: 'calc(100vw-300px)' }"
      >
        <template #type="{ record }">
          <div v-if="activeKey !== null && materialTypeOptins.find((r) => r.value == record.type)">
            {{ materialTypeOptins.find((r) => r.value == record.type).label }}
          </div>

          <div v-else-if="semiFinishedProductOptions.find((r) => r.value == record.type)">
            {{ semiFinishedProductOptions.find((r) => r.value == record.type).label }}
          </div>
        </template>

        <template #linkProject="{ record }">
          <a-button @click="handleLinkProject(record)" size="small">查看</a-button>
        </template>

        <template #action="{ record }">
          <a-space>
            <a-button type="primary" @click="handleUpdateMaterial('update', record)" size="small"
              >修改</a-button
            >

            <a-button @click="handleUpdateMaterial('versionUp', record)" size="small">
              版本更新
            </a-button>
          </a-space>
        </template>
      </a-table>
    </div>

    <div class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        show-size-changer
        :pageSizeOptions="['10', '50', '100', '200', '500']"
        @change="hanldeUpdatePageNum"
        @showSizeChange="hanldeUpdatePageNum"
        :show-total="(total) => `共 ${total} 条`"
      />
    </div>

    <material-form ref="materialFormRef" @updateTable="updateTable"></material-form>

    <a-modal
      v-model:visible="modalConfig.visible"
      :title="modalConfig.title"
      :footer="null"
      width="400px"
    >
      <template v-for="(item, index) in modalConfig.data" :key="item.id">
        <a-space @click="handleJumpBom(item)">
          <div class="click-text">{{ item.project }}</div>
          <a-button type="primary" size="small">点击查看</a-button>
        </a-space>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, inject, nextTick, onActivated, onDeactivated, reactive, ref } from "vue";
import { useTable } from "@/views/notice/serve/table";
import Cookie from "js-cookie";
import {
  getMaterialModelCodeList,
  getProjectLifeCycleByMaterialModelCodeId,
  getProjectLifeCycle,
  exportMaterialModelCode,
} from "@/request/view/project";
import { materialTypeOptins, semiFinishedProductOptions } from "@/views/materialcode/options";
import materialForm from "@/views/materialcode/form.vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Toast, debounce } from "@/utils";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  components: { materialForm, QuestionCircleOutlined },
  setup() {
    const activeKey = inject("activeKey", null);
    const materialFormRef = ref();

    const route = useRoute();
    const router = useRouter();

    const user = useStore().state.user.user;

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    const setSemiProductType = () => {
      return activeKey.value === null ? "P" : activeKey.value;
    };

    const renderContent = ({ text, index }) => {
      const obj = {
        children: text,
        props: {},
      };

      obj.props.rowSpan = table.data[index].rowSpan;
      return obj;
    };

    initPayload({
      search: null,
      type: setSemiProductType(),
    });

    const columns = [
      {
        title: "编码",
        dataIndex: "materialCode",
        align: "center",
        width: "140px",
        customRender: renderContent,
        fixed: "left",
      },
      {
        title: "名称",
        dataIndex: "materialName",
        align: "center",
        width: "220px",
      },
      {
        title: "分类",
        dataIndex: "materialSort",
        align: "center",
        width: "80px",
      },
      {
        title: "规格",
        dataIndex: "specification",
        align: "center",
        width: "160px",
      },
      {
        title: "型号",
        dataIndex: "materialModel",
        align: "center",
        width: "240px",
      },
      {
        title: "属性",
        dataIndex: "attribute",
        align: "center",
        width: "140px",
      },
      {
        title: "版本",
        dataIndex: "edition",
        align: "center",
        width: "80px",
      },
      {
        title: "代码",
        dataIndex: "code",
        align: "center",
        width: "80px",
      },
      {
        title: "单位",
        dataIndex: "unit",
        align: "center",
        width: "80px",
      },
      {
        title: "关联项目",
        align: "center",
        width: "100px",
        slots: {
          customRender: "linkProject",
        },
      },
      // {
      //   title: "类型",
      //   slots: {
      //     customRender: "type",
      //   },
      //   align: "center",
      // },
      // {
      //   title: "备注",
      //   dataIndex: "notes",
      //   align: "center",
      // },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
        fixed: "right",
        width: "160px",
      },
    ];

    requestConfig.pull_fn = getMaterialModelCodeList;

    const handleUpdateMaterial = (type, data) => {
      const titleObj = {
        insert: "新增物料编码",
        update: "修改物料编码",
        versionUp: "新增物料编码",
      };
      materialFormRef.value.showModal({
        title: titleObj[type],
        type,
        data,
      });
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const modalConfig = reactive({
      title: "已关联项目",
      visible: false,
      data: [],
    });

    const handleLinkProject = (record) => {
      modalConfig.data.length = 0;
      getProjectLifeCycleByMaterialModelCodeId({
        materialModelCodeId: record.id,
      }).then((res) => {
        if (!res.data) return Toast("warning", "该物料无项目关联", 3);
        res.data.forEach((item) => {
          item.materialCode = record.materialCode;
        });
        modalConfig.data.push(...res.data);
        modalConfig.visible = true;
      });
    };

    const getBomActiveKey = () => {
      const { secondaryDepartment } = user;

      const key = {
        光学部: "opticsbom",
        结构部: "structurebom",
        电子部: "electronbom",
      };

      return key[secondaryDepartment] || "allbom";
    };

    const handleJumpBom = (record) => {
      let subActiveKey = getBomActiveKey();

      if (record.userId == user.id) subActiveKey = "allbom";

      router.push(
        `/rdprojectlayout?projectLifeCycleId=${record.id}&type=materialLinkBom&subActiveKey=${subActiveKey}&userId=${record.userId}&projectId=${record.id}&materialCode=${record.materialCode}`
      );
    };

    const loading = ref(false);

    const getData = () => {
      loading.value = true;
      getListData()
        .then(() => {
          let duplicateRecord = {
            materialCode: null,
            count: 0,
          };
          loading.value = false;
          table.data.forEach((item, index) => {
            const { materialCode } = item;
            // 初始化赋值
            if (duplicateRecord.materialCode === null) {
              duplicateRecord.materialCode = materialCode;
              duplicateRecord.count = 1;
              item.rowSpan = 1;
            } else if (materialCode === duplicateRecord.materialCode) {
              duplicateRecord.count += 1;
              item.rowSpan = 0;
            }

            // 下一项
            const nextItem = table.data[index + 1];
            const unEqual = nextItem
              ? nextItem.materialCode !== duplicateRecord.materialCode
              : true;
            if (duplicateRecord.count === 1 && !unEqual) {
              item.rowSpan = 0;
            }

            if (duplicateRecord.count !== 1 && unEqual) {
              table.data[index - duplicateRecord.count + 1].rowSpan = duplicateRecord.count;
              item.rowSpan = 0;
            }

            if (unEqual) {
              duplicateRecord.count = 0;
              duplicateRecord.materialCode = null;
            }
          });
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const updateTable = () => {
      table.pageNum = 1;
      getData();
    };

    const handleSearch = debounce(() => {
      if (requestPayload.type == null && activeKey.value === null) {
        requestPayload.type = setSemiProductType();
      }
      table.pageNum = 1;
      getData();
    }, 200);

    const selectedRowKeys = reactive([]);

    const hanldeUpdatePageNum = (page, lineNum) => {
      table.page = page;
      table.lineNum = lineNum;
      selectedRowKeys.length = 0;
      getData();
    };

    const onSelectChange = (rowKey) => {
      selectedRowKeys.length = 0;
      selectedRowKeys.push(...rowKey);
    };

    const exportButtonDisabled = ref(false);

    const handleExportMaterial = () => {
      exportButtonDisabled.value = true;
      exportMaterialModelCode(selectedRowKeys).then((res) => {
        selectedRowKeys.length = 0;
        exportButtonDisabled.value = false;
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `物料编码.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Toast("success", "下载成功", 3);
      }).catch((err) => {
        exportButtonDisabled.value = false;
      });
    };

    onDeactivated(() => {
      Cookie.set(
        "materailParams",
        JSON.stringify({
          page: table.page,
          lineNum: table.lineNum,
          ...requestPayload,
        })
      );
    });

    // getData();
    getData();

    onActivated(() => {
      const paramsString = Cookie.get("materailParams");

      if (paramsString) {
        const params = JSON.parse(paramsString);
        table.data.length = 0;
        table.page = params.page;
        table.lineNum = params.lineNum;
        requestPayload.type = params.type;
        requestPayload.search = params.search;
        getData();
      }
    });

    return {
      table,
      columns,
      loading,
      materialFormRef,
      requestPayload,
      modalConfig,
      updateTable,
      handleJumpBom,
      handleLinkProject,
      hanldeUpdatePageNum,
      semiFinishedProductOptions,
      handleProjectDetails,
      handleUpdateMaterial,
      materialTypeOptins,
      handleSearch,
      activeKey,
      onSelectChange,
      selectedRowKeys,
      exportButtonDisabled,
      handleExportMaterial,
    };
  },
});
</script>

<style lang="less" scoped>
.click-text {
  cursor: pointer;
}

:deep(.ant-table-bordered .ant-table-thead > tr > th) {
  border-right: 1px solid #000;
}

:deep(.ant-table-bordered .ant-table-tbody > tr > td) {
  border-right: 1px solid #000;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #000;
}

:deep(.ant-table-bordered .ant-table-header > table) {
  border: 1px solid #000;
}

:deep(.ant-table-bordered .ant-table-body > table) {
  border: 1px solid #000;
}

:deep(.ant-table-bordered .ant-table-fixed-left table) {
  border: 1px solid #000;
}

:deep(.ant-table-bordered .ant-table-fixed-right table) {
  border: 1px solid #000;
}

:deep(.ant-table-tbody > tr > td) {
  background: #fff !important;
}
</style>
